<template>
  <div class="space-y-8 animate-fade-in-up">
    <div class="mb-8">
      <h2 class="text-3xl font-playfair font-bold text-gray-900 mb-4 flex items-center gap-3">
        <i class="fa-solid fa-timeline text-emerald-500"></i> AI Timeline
      </h2>
      <p class="text-gray-600 font-inter text-lg">Tracking the evolution of AI tools and methodologies from 2024 to 2026.</p>
    </div>

    <div class="relative border-l-2 border-emerald-200 ml-3 pl-8 space-y-10">
      <div v-for="(post, index) in posts" :key="index" class="relative group">
        <!-- Timeline Dot -->
        <div class="absolute -left-[41px] top-1.5 w-5 h-5 rounded-full bg-emerald-100 border-4 border-white shadow-sm group-hover:bg-emerald-500 group-hover:scale-125 transition-all duration-300"></div>
        
        <!-- Content Card -->
        <div class="bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md hover:border-emerald-200 transition-all duration-300 transform group-hover:-translate-y-1">
          <div class="flex flex-col sm:flex-row sm:items-center gap-2 mb-3">
            <span class="text-sm font-semibold text-emerald-700 bg-emerald-50 border border-emerald-100 px-3 py-1 rounded-full w-max">
              {{ post.date }}
            </span>
            <h3 class="text-xl font-bold text-gray-800">{{ post.title }}</h3>
          </div>
          <p class="text-gray-600 font-inter leading-relaxed">{{ post.content }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import postsData from '../assets/ai_posts.json';

export default {
  name: "AiPostsPage",
  data() {
    return {
      posts: postsData
    };
  }
}
</script>
